const timeFmt = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit' })
const dayFmt = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' })
const dateTimeFmt = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
})

const parse = (value: string | null | undefined) => {
    if (!value) return null
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? null : date
}

export const formatTime = (value: string | null | undefined) => {
    const date = parse(value)
    return date ? timeFmt.format(date) : '—'
}

export const formatTimeWithSeconds = (value: string | null | undefined) => {
    const date = parse(value)
    if (!date) return '—'
    return `${timeFmt.format(date)}:${String(date.getSeconds()).padStart(2, '0')}`
}

export const formatDay = (value: string | null | undefined) => {
    const date = parse(value)
    if (!date) return 'Unknown date'
    const today = new Date()
    const sameDay = (a: Date, b: Date) =>
        a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
    if (sameDay(date, today)) return `Today · ${dayFmt.format(date)}`
    const yesterday = new Date(today.getTime() - 86400000)
    if (sameDay(date, yesterday)) return `Yesterday · ${dayFmt.format(date)}`
    return dayFmt.format(date)
}

export const dayKey = (value: string) => {
    const date = parse(value)
    if (!date) return 'unknown'
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
}

/** "3 min ago", "2 h ago", or a short date for anything older than a day. */
export const formatRelative = (value: string | null | undefined) => {
    const date = parse(value)
    if (!date) return '—'
    const diff = Date.now() - date.getTime()
    const minutes = Math.round(diff / 60000)
    if (minutes < 1) return 'just now'
    if (minutes < 60) return `${minutes} min ago`
    const hours = Math.round(minutes / 60)
    if (hours < 24) return `${hours} h ago`
    return dateTimeFmt.format(date)
}

export const formatDuration = (ms: number | null | undefined) => {
    if (ms == null) return '—'
    if (ms < 1000) return `${ms} ms`
    return `${(ms / 1000).toFixed(ms < 10000 ? 1 : 0)} s`
}

/** Time spent on a page before the next visit, as a short label. */
export const formatDwell = (from: string, until: string | null) => {
    const a = parse(from)
    const b = parse(until)
    if (!a || !b) return null
    const seconds = Math.round((b.getTime() - a.getTime()) / 1000)
    if (seconds < 5) return null
    if (seconds < 60) return `${seconds}s`
    const minutes = Math.round(seconds / 60)
    if (minutes < 60) return `${minutes}m`
    const hours = Math.floor(minutes / 60)
    return `${hours}h ${minutes % 60}m`
}
